import { WatchStatus } from './watch-status.interface';
import { notifyError } from '@/core/helpers/notification.helper';
import { client } from '@/server';

export class WatchStatusService {
   async getWatchStatuses() {
      const query = `SELECT * FROM watch_status ORDER BY rank ASC`;

      try {
         const response = await client.execute(query);
         return response.rows as unknown as Array<WatchStatus>;
      } catch (error) {
         console.error('Error fetching watch statuses:', error);
         notifyError({ title: 'Something went wrong while fetching the watch statuses' });
      }
   }
}
